import { DateTime } from "luxon";

// The purpose of this
export function formatISOString(isoDateString) {
  try {
    const parts = isoDateString.split("T")[0].split("-");
    const year = parts[0];
    const month = parts[1];
    const day = parts[2];
    return `${month}/${day}/${year}`;
  } catch (err) {
    return "Invalid ISO Date";
  }
}

export function prettyFormattedDateFromISO(
  isoDateString,
  timeZone = "America/Toronto"
) {
  // DEVELOPERS NOTE: Run two different algorithms.

  try {
    console.log("prettyFormattedDateFromISO | Primary | Input:", isoDateString);

    // Create a Luxon DateTime object from the input string in the specified time zone
    const date = DateTime.fromISO(isoDateString, { zone: timeZone });

    if (isNaN(date)) {
      console.log("prettyFormattedDateFromISO | Primary | Invalid DateTime");
      throw new Error("Invalid DateTime");
    }

    // Format the date as "MM/DD/YYYY"
    const formattedDate = date.toFormat("MM/dd/yyyy");

    console.log(
      "prettyFormattedDateFromISO | Primary | Output:",
      formattedDate
    );
    return formattedDate;
  } catch (err) {
    try {
      console.log(
        "prettyFormattedDateFromISO | Secondary | Input:",
        isoDateString
      );

      // Create a JavaScript Date object from the input string
      const date = new Date(isoDateString);

      // Extract the individual date components
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // Adding 1 because getMonth() is zero-based
      const day = date.getDate();

      // Format the date as "MM/DD/YYYY"
      const formattedDate = `${month}/${day}/${year}`;

      console.log(
        "prettyFormattedDateFromISO | Secondary | Output:",
        formattedDate
      );
      return formattedDate;
    } catch (err) {
      return "Invalid ISO Date";
    }
  }
}

export function prettyFormattedDateTimeFromISO(
  isoDateTimeString,
  timeZone = "America/Toronto"
) {
  if (isoDateTimeString === "") {
    return "";
  }
  try {
    // Create a JavaScript Date object from the input string
    const date = new Date(isoDateTimeString);

    // Use the provided time zone
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
      timeZone: timeZone,
    };

    // Format the date and time as "MM/DD/YYYY h:mm AM/PM" in the specified time zone
    const formattedDateTime = new Intl.DateTimeFormat("en-US", options).format(
      date
    );

    console.log("prettyFormattedDateTimeFromISO | Input:", isoDateTimeString);
    console.log("prettyFormattedDateTimeFromISO | Output:", formattedDateTime);
    return formattedDateTime;
  } catch (err) {
    return "Invalid ISO Date/Time";
  }
}

export function prettyFormattedTimeFromISO(
  isoDateTimeString,
  timeZone = "America/Toronto"
) {
  // Create a JavaScript Date object from the input string, considering the specified time zone
  const date = new Date(isoDateTimeString);
  const options = {
    timeZone,
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  // Format the time as "h:mm AM/PM" in the specified time zone
  const formattedTime = new Intl.DateTimeFormat("en-US", options).format(date);

  console.log("prettyFormattedTimeFromISO | Input:", isoDateTimeString);
  console.log("prettyFormattedTimeFromISO | timeZone:", formattedTime);

  return formattedTime;
}

export function formatDurationFromSeconds(seconds) {
  const years = Math.floor(seconds / (365 * 24 * 3600));
  const days = Math.floor((seconds % (365 * 24 * 3600)) / (24 * 3600));
  const hours = Math.floor((seconds % (24 * 3600)) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  if (years > 0) {
    return `${years} yr${years > 1 ? "s" : ""}, ${days} day${
      days > 1 ? "s" : ""
    }`;
  } else if (days > 0) {
    return `${days} day${days > 1 ? "s" : ""}, ${hours} hr${
      hours > 1 ? "s" : ""
    }`;
  } else if (hours > 0) {
    return `${hours} hr${hours > 1 ? "s" : ""}, ${minutes}:${
      remainingSeconds < 10 ? "0" : ""
    }${remainingSeconds} min`;
  } else if (minutes > 0) {
    return `${minutes}:${
      remainingSeconds < 10 ? "0" : ""
    }${remainingSeconds} min`;
  } else {
    return remainingSeconds > 0 ? `0${remainingSeconds} sec` : "0 sec";
  }
}

export function secondsToMinutesHours(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  if (hours > 0) {
    return `${hours} hr${hours > 1 ? "s" : ""}`;
  } else if (minutes > 0) {
    return `${minutes}:${
      remainingSeconds < 10 ? "0" : ""
    }${remainingSeconds} min`;
  } else {
    return remainingSeconds > 0 ? `0${remainingSeconds}:sec` : 0;
  }
}
